import React, { useCallback } from "react";
import {
  Box,
  Button,
  Chip,
  Container,
  Paper,
  Stack,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import ImageIcon from "@mui/icons-material/Image";
import { BodyText } from "../../../widgets/TemplatePreview";
export const renderHeader = (data) => {
  if (!data.header || !data.header.type) return null;
  const { type, link, text } = data.header;
  switch (type) {
    case "image":
      return (
        <Box
          component="img"
          src={link}
          alt="header"
          sx={{
            width: "100%",
            maxHeight: 250,
            objectFit: "contain",
            borderRadius: 1,
            my: 1,
          }}
        />
      );

    case "video":
      return (
        <Box sx={{ my: 1 }}>
          <Box
            component="video"
            src={link}
            controls
            style={{ width: "100%", borderRadius: 8 }}
          />
        </Box>
      );

    case "document":
      return (
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            px: 1.5,
            py: 1,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            my: 1,
          }}
        >
          <PictureAsPdfOutlinedIcon color="action" fontSize="large" />
          <MuiLink
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            {link.split("/").pop()}
          </MuiLink>
        </Stack>
      );

    case "text":
      return (
        <Stack sx={{ my: 1 }} direction="row" alignItems="center" spacing={1}>
          <ImageIcon color="disabled" />
          <Typography variant="subtitle2">{text}</Typography>
        </Stack>
      );

    default:
      return (
        <Stack sx={{ my: 1 }} direction="row" alignItems="center" spacing={1}>
          <InsertDriveFileOutlinedIcon color="action" />
          <MuiLink
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            {link}
          </MuiLink>
        </Stack>
      );
  }
};

const ShowInteractiveButtons = ({ data, onOpen, preview = false }) => {
  const handleButtonClick = useCallback((button) => {
    console.log(button);
  }, []);

  return (
    <Container maxWidth="md">
      <Paper variant="outlined" elevation={0} sx={{ p: 2 }}>
        {!preview && (
          <Stack direction="row" spacing={1} flexWrap="wrap" my={1}>
            {(data.triggerText || []).map((item) => (
              <Chip key={item} variant="outlined" label={item} clickable />
            ))}
          </Stack>
        )}
        {renderHeader(data)}
        <BodyText sx={{ my: 1 }}>{data.body}</BodyText>
        <Stack spacing={2} flexWrap="wrap" my={1}>
          {(data.buttons ?? []).map((btn) => (
            <Button
              fullWidth
              key={btn.id}
              variant="contained"
              size="small"
              sx={{ textTransform: "none", minWidth: 100 }}
              onClick={() => handleButtonClick(btn)}
            >
              {btn.title}
            </Button>
          ))}
        </Stack>
        {data.footer && (
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            mt={0.5}
          >
            {data.footer}
          </Typography>
        )}
        {!preview && (
          <Stack direction="row" justifyContent="end" mt={2}>
            <Button
              onClick={() => onOpen?.()}
              startIcon={<AddIcon />}
              variant="outlined"
              size="small"
            >
              Add trigger
            </Button>
          </Stack>
        )}
      </Paper>
    </Container>
  );
};

export default ShowInteractiveButtons;
